import { ContentIcon } from "@dropbox/dash-component-library";
import { Text } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { SearchLine } from "@dropbox/dig-icons/dist/mjs/assets";
import { getTypeaheadFilterDisplayProps } from "@mirage/mosaics/SearchBarWithTypeahead/typeahead-search-filter-result";
import { Highlighter } from "@mirage/search/SearchResults/Highlighter";
import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import {
  peopleRecommendationToSearchFilter,
  SearchFilterKeyword,
  withDelimiter,
} from "@mirage/shared/search/search-filters";
import i18n from "@mirage/translations";
import { FilterChip } from "../FilterChip";
import { BaseResultRow } from "./BaseResultRow";

export const PeopleFilterResultRow = ({
  scoredResult: { result },
  currentQuery,
}: {
  scoredResult: typeahead.ScoredPeopleFilter;
  isSelected: boolean;
  currentQuery: string;
}) => {
  const chipContent = result.displayName ?? result.email;

  const highlightWords = currentQuery
    ? currentQuery.split(" ").map((word) => word.trim())
    : [];

  const metadataText = i18n.t("omnibox_people_filter_metadata");

  const { icon } = getTypeaheadFilterDisplayProps(
    currentQuery!,
    peopleRecommendationToSearchFilter(result)!,
  );

  return (
    <BaseResultRow
      icon={
        <ContentIcon
          icon={
            <UIIcon src={SearchLine} color={"var(--dig-color__text__base)"} />
          }
          size="large"
          hasBackground={false}
        />
      }
      richTitle={
        <FilterChip
          filterIcon={
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              columnGap="Micro XSmall"
            >
              <Text size="medium" color="subtle">
                {withDelimiter(SearchFilterKeyword.Person)}
              </Text>
              {icon}
            </Box>
          }
          title={
            <Highlighter
              title={chipContent}
              highlightWords={highlightWords}
              fontSize={"large"}
            />
          }
        />
      }
      subtitle={metadataText}
    />
  );
};
